// src/pages/Privacy.tsx
import { SeoHead } from '@/components/SeoHead';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { useLanguage } from '@/hooks/useLanguage';
import { privacyPolicy } from '@/lib/legal-content';
import { localePath } from '@/i18n/paths';

const seoContent = {
  pl: {
    title: 'Polityka Prywatności | Bookeper AI',
    description:
      'Polityka prywatności Bookeper AI. Dowiedz się, jak przetwarzamy i chronimy Twoje dane osobowe.',
  },
  en: {
    title: 'Privacy Policy | Bookeper AI',
    description: 'Bookeper AI Privacy Policy. Learn how we process and protect your personal data.',
  },
  uk: {
    title: 'Політика Конфіденційності | Bookeper AI',
    description:
      'Політика конфіденційності Bookeper AI. Дізнайтеся, як ми обробляємо та захищаємо ваші персональні дані.',
  },
} as const;

export default function Privacy() {
  const lang = useLanguage();
  const seo = seoContent[lang];

  return (
    <>
      <SeoHead>
        <html lang={lang} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`https://www.bookeper.pl${localePath('/privacy', lang)}`} />
      </SeoHead>
      <LegalPageLayout document={privacyPolicy[lang]} />
    </>
  );
}
